import { NgModule } from '@angular/core';
import { BeginComponent } from './begin/begin.component';
import { RouterModule } from '@angular/router';
import { CongressComponent } from './congress.component';
import { EventsComponent } from './events/events.component';
import { CredentialComponent } from './credential/credential.component';
import { JoinAnuuityComponent } from './join-anuuity/join-anuuity.component';

@NgModule({
    imports: [RouterModule.forChild([
        {
          path: '',
          component: CongressComponent,
          children: [
            { path: 'home', component: BeginComponent },
            { path: 'eventos/:type', component: EventsComponent },
            { path: 'eventos', component: EventsComponent },
            { path: 'credencial', component: CredentialComponent },
            { path: 'anuidade', component: JoinAnuuityComponent },
          ]
        }
      ])
    ],
    exports: [RouterModule]
})
export class CongressRoutingModule { }



// WEBPACK FOOTER //
// ./src/congress/congress-routing.module.ts